import { render, staticRenderFns } from "./PtzCameraRectTouchSelectController.vue?vue&type=template&id=36a5674c&scoped=true&"
import script from "./PtzCameraRectTouchSelectController.vue?vue&type=script&lang=js&"
export * from "./PtzCameraRectTouchSelectController.vue?vue&type=script&lang=js&"
import style0 from "./PtzCameraRectTouchSelectController.vue?vue&type=style&index=0&id=36a5674c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a5674c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
